import React from 'react';
import { Box } from '@material-ui/core';

import { ModalTitle, ModalTypography } from 'components/Modal/Modal';
import { ModalStep } from 'components/Flow/components/ModalStep';
import { DeedHeartHands } from 'components/Flow/components/DeedHeartHands';
import { StepComponentProps } from 'components/Flow/RenderMachine';
import { BackButton } from 'components/BackButton/BackButton';

export const NoCreds = ({ send }: StepComponentProps): JSX.Element => (
  <ModalStep
    showProgressBar
    actions={
      <div>
        <BackButton onClick={(): unknown => send?.('PREV')} />
      </div>
    }
    header={<DeedHeartHands />}
    headerStyles={{
      paddingTop: 16,
    }}
  >
    <Box>
      <ModalTitle>PayPal Business Account Access Required</ModalTitle>
      <ModalTypography>
        It looks like you don’t have the credentials for the PayPal Business account associated with
        your entity. To proceed with the nonprofit onboarding process, please contact the person at
        your organization who has access to your organization’s PayPal account. If you cannot get
        access to the PayPal login credentials, please contact PayPal customer support. Once the
        account is verified, the nonprofit admin can add additional users.
      </ModalTypography>
    </Box>
  </ModalStep>
);
